Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Strava = void 0;

var _react = _interopRequireDefault(require("react"));

var _generalObserver = require("../general-observer");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Strava = function Strava(_ref) {
  var activityId = _ref.activityId;
  return /*#__PURE__*/_react["default"].createElement(_generalObserver.GeneralObserver, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "strava-mdx-embed",
    style: {
      position: 'relative',
      height: '350px',
      maxWidth: '568px',
      width: '100%',
      overflow: 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    title: "strava-".concat(activityId),
    className: "strava-mdx-embed",
    height: "100%",
    width: "100%",
    style: {
      minWidth: '380px'
    },
    frameBorder: "0",
    scrolling: "no",
    src: "https://www.strava.com/activities/".concat(activityId)
  })));
};

exports.Strava = Strava;